import useDebounce from '@UI/Hooks/useDebounce';
import staffMemberFiltersSignal, {
	setStaffMemberFilters,
} from '@UI/Pages/Agencies/StaffMembers/Filters/Signals/staffMemberFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { InputText } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS = 300;

/**
 * Keeps local state for immediate keystroke feedback while the write to `staffMemberFiltersSignal`
 * is debounced; the local state follows the signal so an external reset empties the field.
 */
const SearchFilter: React.FC = () => {
	const currentFilters = useSignalValue(staffMemberFiltersSignal);
	const [searchInput, setSearchInput] = React.useState(currentFilters.search);
	const debouncedSearch = useDebounce(searchInput, SEARCH_DEBOUNCE_DELAY_IN_MILLISECONDS);

	React.useEffect(() => {
		setSearchInput(currentFilters.search);
	}, [currentFilters.search]);

	React.useEffect(() => {
		if (debouncedSearch === staffMemberFiltersSignal.peek().search) {
			return;
		}

		setStaffMemberFilters(staffMemberFiltersSignal.peek().setSearch(debouncedSearch));
	}, [debouncedSearch]);

	const handleSearchChange = React.useCallback((value: string) => {
		setSearchInput(value);
	}, []);

	return (
		<InputText
			name="staffMemberSearch"
			label="Recherche"
			isLabelHidden
			placeholder="Nom ou prénom"
			value={searchInput}
			onChange={handleSearchChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default SearchFilter;
